import React from 'react';
import { 
    List, 
    Datagrid, 
    TextField,
    ReferenceField,
    usePermissions,
    useResourceContext,
    EditButton
} from 'react-admin';
import { processPermissions, isAdminUser } from "../../common/roleUtils";

export const SectionList = props => {
    const { permissions } = usePermissions();
    const resource = useResourceContext();
    
    const propsObj = processPermissions(permissions, resource);
    const allowBulkActions = isAdminUser();
    
    return (
        <React.Fragment>
            <List 
                title="Sections" 
                {...props} 
                {...propsObj}
                sort={{ field: 'id', order: 'ASC' }}
            >
                <Datagrid 
                    rowClick={propsObj.hasEdit ? 'edit' : false} 
                    bulkActionButtons={allowBulkActions ? undefined : false}
                >
                    {propsObj.hasEdit && <EditButton />}
                    <TextField source="id" />
                    <ReferenceField source="class_id" reference="genere" label="Class" link={false}>
                        <TextField source="class_name" />
                    </ReferenceField>
                    <TextField source="section" label="Section Name" />
                </Datagrid>
            </List>
        </React.Fragment>
    )
}
